<template>
  <div v-if="service_point.services" class="font-14-991" :id="`popover-target-${service_point.id}-${id_prefix}`">
    <div class="mb-lg-1 mb-md-2" v-for="(service, key) in service_point.services.slice(0,display_service_limit)" :key="key">
      <i v-if="service.vehicle_type == 'Car'" class="car-service-icon" style="width: 20px;"></i>
      <i v-if="service.vehicle_type == 'Light Truck'" class="van-icon" style="width: 20px;"></i>
      <i v-if="service.vehicle_type == 'Truck'" class="truck-service-icon" style="width: 20px;"></i>

      <template v-if="service.is_price_per_quantity=='1'">
        {{ service.service_name}} {{ rimSizeIcon(service.diameter)}} - {{ formatPrice(service.price) }} / {{ $t("unit")}}
      </template>
      <template v-if="service.is_price_per_quantity=='0'">
        {{ service.service_name}} {{ rimSizeIcon(service.diameter)}} - {{ formatPrice(service.price) }} / {{ $t("unit")}}
      </template>
    </div>
    <b-popover :target="`popover-target-${service_point.id}-${id_prefix}`" triggers="hover" placement="top">
      <div class="popover-service-container">
        <p class="mb-1" v-for="(service, key) in service_point.services.slice(display_service_limit)" :key="key" style="border-bottom: 1px solid #e2e2e2">
          <i v-if="service.vehicle_type == 'Car'" class="car-service-icon" style="width: 20px;"></i>
          <i v-if="service.vehicle_type == 'Light Truck'" class="van-icon" style="width: 20px;"></i>
          <i v-if="service.vehicle_type == 'Truck'" class="truck-service-icon" style="width: 20px;"></i>

          <template v-if="service.is_price_per_quantity=='1'">
            {{ service.service_name}} {{ rimSizeIcon(service.diameter)}} - {{ formatPrice(service.price) }} / {{ $t("unit")}}
          </template>
          <template v-if="service.is_price_per_quantity=='0'">
            {{ service.service_name}} {{ rimSizeIcon(service.diameter)}} - {{ formatPrice(service.price) }} / {{ $t("unit")}}
          </template>
        </p>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "HomeViewAttachedService",
  props : ["service_point", "id_prefix", "display_service_limit"],
  methods : {

  }
}
</script>

<style scoped>
.van-icon, .car-service-icon {
  margin-right: 4px;
}
</style>